import { api } from "assets/scripts/utilities/api-clients";

export const index = async () => {
  const response = await api.get(`/kam/payment-terms`);

  return response;
};
